// Outil de sélection de selle (sections/saddle-finder.liquid).
// Sans JS, toutes les recommandations restent visibles ; avec JS, seule celle
// de l'option active est affichée. La première option est présélectionnée —
// l'ordre des blocks dans le template décide donc de l'orientation par défaut
// (Confort/VAE en premier, cf. BUILD_PLAN §1).
class SaddleFinder extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-finder-option]'));
    this.panels = Array.from(this.querySelectorAll('[data-finder-panel]'));
    if (this.buttons.length === 0) return;

    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.select(button.dataset.finderOption));
    });

    this.select(this.buttons[0].dataset.finderOption);
  }

  select(id) {
    this.buttons.forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.finderOption === id));
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.finderPanel !== id;
    });
  }
}

if (!customElements.get('saddle-finder')) {
  customElements.define('saddle-finder', SaddleFinder);
}
